import { render, staticRenderFns } from "./mnPp.vue?vue&type=template&id=652f0e46"
import script from "./mnPp.vue?vue&type=script&lang=js"
export * from "./mnPp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports